__turbopack_context__.v({
  "className": "jersey_25_e3626e58-module__ZO5ZYW__className",
});
